import { render, staticRenderFns } from "./SidebarButtons.vue?vue&type=template&id=5a23bfbf&scoped=true&"
import script from "./SidebarButtons.vue?vue&type=script&lang=js&"
export * from "./SidebarButtons.vue?vue&type=script&lang=js&"
import style0 from "./SidebarButtons.vue?vue&type=style&index=0&id=5a23bfbf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23bfbf",
  null
  
)

export default component.exports